<template>
  <div>
    <multiselect  id="associatedUser" v-model="localModel" @input="onChange" 
      track-by="id" :customLabel="userSelectLabel" :options="userOptions" :multiple="false" :show-no-results="true"
      :searchable="true" :loading="isLoadingUser" :internal-search="true" :close-on-select="true" 
      :options-limit="10" :limit="3" :taggable="false" :max-height="600" :allow-empty="true"  :hide-selected="false" 
      :placeholder="$t('user.user')" @search-change="usersAsyncFind"
      v-bind:deselect-label="$t('multiselect.deselect-label')"
      v-bind:selectedLabel="$t('multiselect.selectedLabel')"
      v-bind:select-label="$t('multiselect.select-label')">
      <span slot="noResult">{{ $t('multiselect.not-found') }} </span>
    </multiselect>
  </div>
</template>

<script>
  import {UserServiceClient, UserDto} from '../../shared/service-clients/service-clients'
  import ServiceFactory from '../../shared/service-clients/serviceClientFactory'
  import Multiselect from 'vue-multiselect'

  export default {
    name: 'UserMultiselect',
    props: {
      model: {},
    },
    data() {
      return {
        localModel: {},
        userOptions: [],
        isLoadingUser: false,
      }
    },
    watch: {
      model: {
        immediate: true,
        handler(newVal, oldVal) {
          this.localModel = newVal
        },
      },
    },
    inject: ['$validator'],
    methods: {
      onChange(value) {
        this.$emit('update', value)
      },
      userSelectLabel: function(option) {
        return option.id + ' - ' + option.firstName + ' ' + option.lastName
      },
      usersAsyncFind: function(query) {
        if (query.length > 0) {
          this.isLoading = true
          let service = ServiceFactory.create(UserServiceClient)

          let self = this
          service.getAutocomplete(query).then(response => {
            self.userOptions = _.map(response, user => {
              let userDto = new UserDto()
              userDto.init(user)
              return userDto
            })

            self.isLoading = false
          })
        }
      },
    },
    components: {
      multiselect: Multiselect,
    },
  }
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style>
</style>



// WEBPACK FOOTER //
// src/shared/multiselect/UserMultiselect.vue